export const environment = {
    production: false,
    TENANT_NR: "64",
    TENANT_SERVER_URL: "https://bs00-office.test.azure.fsq-gmbh.net",
    BASE_API_URL: `https://bs00.test.azure.fsq-gmbh.net/skitbs-rest/rest/skitbs_mobile/v1`,
    TENANT_NAME: "food safety qualITy GmbH",
    TENANT_SVC_EMAIL: "service@meinibs.de",
    TENANT_SVC_PHONE: "030 - 2332481 22",
    TENANT_SVC_FAX: "030 - 540044479",
    TENANT_OBJECTNR_LENGTH: "8",
    TENANT_ADVERTISING_PORTAL: "https://fsq-gmbh.de",
    REGISTRATION_URL: "https://bs00-registration.test.azure.fsq-gmbh.net",
    MATOMO_SITE_ID: null,
    backgroundColor: '#164474',
    logoImage: "../assets/images/logo_icon.svg"
};
